import { useEffect, useState } from "react";

const CustomStatusBar = ({ api, component = '', totalCount = '' }) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    const updateCount = () => {
      if (!api || api.isDestroyed()) return; // Ensure the grid is not destroyed
      let matchingRows = 0;

      api.forEachNode((node) => {
        if (component === "campaigns") {
          if (node.data && node.data?.campaignName && !['Channel', 'Publisher'].includes(node?.data?.title)) {
            matchingRows++;
          }
        } else {
          if (node.data && !['Channel', 'Publisher'].includes(node?.data?.title)) {
            matchingRows++;
          }
        }
      });

      setCount(matchingRows);
    };

    if (api && !api.isDestroyed()) {
      api.addEventListener("modelUpdated", updateCount);
      updateCount(); // Initial count
    }

    return () => {
      if (api && !api.isDestroyed()) {
        api.removeEventListener("modelUpdated", updateCount); // Remove listener only if the grid is not destroyed
      }
    };
  }, [api]);

  return (
    <div style={{ padding: "10px" }}>
      {component === "campaigns" ?
        (<>Showing {count} of {totalCount}</>) :
        (<>Total Rows: {count}</>)
      }
    </div>
  );
};

export default CustomStatusBar;